import { useEffect, useState } from "react";
import { useFetchFieldGames, useFetchFields } from "../../../api/hooks";
import i18n from "../../../i18n";
import PageContainer from "../../../uikit/PageContainer/PageContainer";
import SelectDropdown from "../../../uikit/SelectDropdown/SelectDropdown";
import FieldGames from "../components/FieldGames";
import { useAptabase } from "@aptabase/react";
import { S3Image } from "../../../components/S3Image";

const FieldsPage = () => {
  const [selectedFieldId, setSelectedFieldId] = useState<string>();
  const { data: fields } = useFetchFields();
  const selectedField = fields?.find((field) => field._id === selectedFieldId);

  useEffect(() => {
    if (fields?.length && !selectedFieldId) {
      setSelectedFieldId(fields?.[0]._id);
    }
  }, [fields, selectedFieldId]);

  const { data } = useFetchFieldGames({
    fieldId: selectedFieldId,
  });
  const { trackEvent } = useAptabase();

  useEffect(() => {
    trackEvent("page_view", { screenName: "fields_page" });
  }, [trackEvent]);

  const onSelectField = (value: string) => {
    setSelectedFieldId(value);
    trackEvent("select_field", { field: value });
  };

  return (
    <PageContainer title={i18n.t("navigation:fields:title")}>
      <div className="flex flex-row justify-between items-end">
        {/** Show field challenge label */}
        {/* {selectedChallenge && (
          <div className="text-center text-2xl font-bold mt-4">
            {selectedChallenge}
          </div>
        )} */}
        {fields?.length && (
          <SelectDropdown
            options={fields?.map((field) => ({
              value: field._id,
              label: field.name,
            }))}
            onSelect={onSelectField}
            selected={selectedFieldId}
            placeholder={i18n.t("navigation:header:selector:field")}
            direction="left"
          />
        )}
      </div>

      <div className="pt-5 lg:grid lg:grid-cols-2 lg:gap-4">
        {selectedField?.image_key ? (
          <div className="col-span-1">
            <S3Image
              keyPath={selectedField?.image_key}
              placeholder={selectedField?.image_key}
              alt={selectedField?.name ?? ""}
              className="w-full"
            />
          </div>
        ) : (
          <div className="col-span-1">
            <div className="w-full h-full bg-gray-200 animate-pulse rounded" />
          </div>
        )}
        <div className="col-span-1 pt-5 lg:pt-0">
          <FieldGames games={data} />
        </div>
      </div>
    </PageContainer>
  );
};

export default FieldsPage;
